import { computed, shallowReactive } from 'vue'

export default () => {
  const rowSelection = shallowReactive<any>({
    selectedRowKeys: [],
    selectedRowRecords: [],
    fixed: true,
    preserveSelectedRowKeys: true,
    onChange(keys, selectedRows): void {
      rowSelection.selectedRowRecords = selectedRows
      rowSelection.selectedRowKeys = keys
    }
  })
  const hasRowSelected = computed(() => rowSelection.selectedRowKeys.length > 0)
  const moreActionDisabled = computed(() => !!rowSelection.selectedRowKeys.length)
  return {
    rowSelection,
    hasRowSelected,
    moreActionDisabled
  }
}
